import React from "react";
import RadioButtonGroup from "./RadioButtonGroup";
import PropTypes from "prop-types";


const TrueFalseRadioButtonGroup = (props) => {
	const radiobuttongroupTrueFalse = [{ value: true, label: props.trueLabel }, { value: false, label: props.falseLabel }];
	props = Object.assign({}, props, {
		items: radiobuttongroupTrueFalse
	});

	return (
		<RadioButtonGroup {...props} />
	);
};


TrueFalseRadioButtonGroup.propTypes = {
	trueLabel: PropTypes.string.isRequired,
	falseLabel: PropTypes.string.isRequired,
};
export default TrueFalseRadioButtonGroup;
